import React, { useEffect, useState } from 'react';
import FlashingDot from '../FlashingDot';
import HobbyModal from './HobbyModal';

const Hobbies = ({ trackedObjects }) => {
  const [isHobbyModalOpen, setIsHobbyModalOpen] = useState(false);

  const [tv, setTv] = useState(null);

  useEffect(() => {
    setTv(trackedObjects.find(o => o.name.toLowerCase() === 'declan-rice'));
  }, [trackedObjects]);

  function showHobbyModal() {
    setIsHobbyModalOpen(true);
  }

  return (
    <>
      {tv && <FlashingDot onClick={showHobbyModal} position={{ x: tv.pos.x, y: tv.pos.y }}/>}
      <HobbyModal
        isModalOpen={isHobbyModalOpen}
        setIsModalOpen={setIsHobbyModalOpen}
      />
    </>
  );
};

export default Hobbies;